import React, { useState } from "react";

// import * as FiIcons from "react-icons/fi";
// Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Componentes
import { SmsByDateGraph } from "../components/SmsByDateGraph";
import HomeCards from "../components/Cards/HomeCards";

//Widgets
import WidgetMessages from "../components/widgets/widgetMessages";
import { useAuth } from "../Context/AuthContext";
import AdminDashboard from "./Dashboards/AdminDashboard";
import WidgetNextCampaigns from "../components/widgets/widgetNextCampaigns";

const Home = () => {
  const Auth = useAuth();
  const { vc_name: userName } = Auth.getSessionData();
  const [date, setDate] = useState(0);
  // const getPackageData = () => {
  //   var userData = Auth.getSessionData();
  //   setUserName(userData.vc_name);

  //   if (userData.uid_partner == null) return;
  //   const URIPartnerPackage =
  //     ApiEndpoint +
  //     "campaigns/getPartnerCurrentPackage/" +
  //     userData.uid_partner;

  //   httpClient(
  //     "POST",
  //     URIPartnerPackage,
  //     {
  //       idpartner: userData.uid_partner,
  //       limit: 10,
  //       user: userData.uid_user,
  //     },
  //     userData.token
  //   ).then(function (response) {
  //     setPackageData(response.data);
  //   });
  // };

  return (
    <>
      <div className="">
        <div>
          <h2>Dashboard</h2>
          <h3>Bienvenido {userName ?? ""}.</h3>
        </div>
      </div>
      {!Auth.isAdminRole() ? (
        <>
          {/* <Row>
            <GenericWidget
              className={"Widget1"}
              title={"SMS"}
              legend={"Mes Actual"}
              quantity={10}
              sizexs={"3"}
              sizesm={"3"}
              icon={<FiIcons.FiDollarSign />}
            ></GenericWidget>
            <GenericWidget
              className={"Widget2"}
              title={"Emails"}
              legend={"Mes Actual"}
              quantity={20}
              sizexs={"3"}
              sizesm={"3"}
              icon={<FiIcons.FiMail />}
            ></GenericWidget>
            <GenericWidget
              className={"Widget3"}
              title={"Whatsapp"}
              legend={"Mes Actual"}
              quantity={30}
              sizexs={"3"}
              sizesm={"3"}
              icon={<FiIcons.FiSend />}
            ></GenericWidget>
            <GenericWidget
              className={"Widget3"}
              title={"RCS"}
              legend={"Mes Actual"}
              quantity={30}
              sizexs={"3"}
              sizesm={"3"}
              icon={<FiIcons.FiSend />}
            ></GenericWidget>
          </Row>  */}
          <HomeCards onChangeDate={setDate} date={date} />
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="chart">
                <SmsByDateGraph onChangeDate={setDate} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={6} sm={6} md={6} lg={6} xl={6}>
              <WidgetMessages />
            </Col>{" "}
            <Col xs={6} sm={6} md={6} lg={6} xl={6}>
              <WidgetNextCampaigns />
            </Col>
          </Row>
        </>
      ) : (
        <AdminDashboard />
      )}
    </>
  );
};

export default Home;
